import React, { createContext, useContext, useEffect, useState } from "react";
import GetGlobalSettingsApi from "../api/global-settings/GetGlobalSettingsApi";

const DEFAULT_SETTINGS = {
  treeView: false,
  fullTreeView: false,
  manageHierarchy: false,
  showHome: true,
  defaultLandingPage: '/my-plans',
  showSynergen: true,
  enhancedSecurity: false,
};

const GlobalSettingsContext = createContext(DEFAULT_SETTINGS);

export function GlobalSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    GetGlobalSettingsApi().then((res) => {
      if (res?.success) {
        setSettings(res.data);
      }
    });

    // Re-fetch when permissions are updated (e.g. after admin changes settings)
    const handleUpdate = () => {
      GetGlobalSettingsApi().then((res) => {
        if (res?.success) setSettings(res.data);
      });
    };
    window.addEventListener("globalSettingsUpdated", handleUpdate);
    return () => window.removeEventListener("globalSettingsUpdated", handleUpdate);
  }, []);

  return (
    <GlobalSettingsContext.Provider value={settings}>
      {children}
    </GlobalSettingsContext.Provider>
  );
}

export function useGlobalSettings() {
  return useContext(GlobalSettingsContext);
}

export default GlobalSettingsContext;
